import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { format, differenceInYears } from "date-fns";
import { toastr } from "react-redux-toastr";
import { Customer, Address } from "../../../core/api/models";
import { State } from "../../../core/store/interfaces";
import DateInput from "../../../components/form-group/date-input";
import ErrorMessage from "../../../components/text/ErrorMessage";
import noImage from "../user-noimage.png";
import EditName from "./EditName";
import EditPhone from "./EditPhone";
import EditEmail from "./EditEmail";
import AddAddress from "./AddAddress";
import EditFiled from "./EditFiled";
import EditDOB from "./EditDOB";
import api from "../../../api";
import {
  useLead,
  capitalizeFirstLetter,
  AppPermissions,
  useHasPermission,
  convertPascalCaseToWords,
} from "../../../core";
import { Controller, useForm } from "react-hook-form";
import EditCivilId from "../../leads/components/EditCivilId";
import { RouteKeys } from "../../routes/route-keys";
import { CustomerAvatar } from "../../../components/render-file/CustomerAvatar";
import { DownloadLink } from "../../../components/render-file/DownloadLink";
import EditSelectField from "./company-customer/EditSelectField";
import {
  CustomerEditModalType,
  customerContactType,
  isVerified,
} from "../../../core/api/models/customer";
import { AgeLimit } from "../../../core/models/customer";
import NonCompanyCustomerFields from "./NonCompanyCustomerFields";
import AddressDetalsView from "./AddressDetalsView";
import EmailLink from "../../../components/emailLink/EmailLink";
import PhoneNumberCopy from "../../../components/phoneNumberCopy/PhoneNumberCopy";

const SearchCustomer: React.FunctionComponent<{
  error?: string;
  setStage: (stage: string) => void;
  updateUser: (details: Customer) => void;
  customerDetails?: Customer;
  show360Link?: boolean;
}> = (props) => {
  const history = useHistory();
  const canSetLeadClosingDate = useHasPermission(AppPermissions.SetLeadClosingDate);
  const canUpdateCustomerContacts = useHasPermission(AppPermissions.UpdateCustomerContacts);

  const canViewCustomerAddress = useHasPermission(AppPermissions.ViewCustomerAddress);

  const leadState = useSelector((state: State) => state.lead);
  const { updateSetClosingDate } = useLead(api.lead);
  const { control, handleSubmit, errors } = useForm<{ date: Date }>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const [addressToDelete, setAddressToDelete] = useState<Address>();

  const [editModal, setEditModal] = React.useState<CustomerEditModalType>({});
  const [isShowMore, setShowMore] = useState<boolean>(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const [isShowSetExpectedCloseDate, setShowSetExpectedCloseDate] = useState<boolean>(false);
  const [selectedAddress, setSelectedAddress] = useState<Address>();

  const selectAddress = (address?: Address) => {
    setSelectedAddress(address);
    setEditModal({ isShowAddressForm: true });
  };

  // React.useEffect(() => {
  //   document.addEventListener("click", handleClickOutside, false);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, false);
  //   };
  // }, []);

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef?.current &&
      !wrapperRef.current.contains(event.target) &&
      !event?.target?.className?.includes("react-datepicker__day")
    ) {
      setShowSetExpectedCloseDate(false);
    }
  };

  const onCloseDeleteConfirm = () => {
    setAddressToDelete(undefined);
  };

  const onRemoveAddress = async () => {
    let addresses =
      props.customerDetails && props.customerDetails?.addresses
        ? props.customerDetails?.addresses
        : [];
    if (addressToDelete) {
      addresses = addresses.filter((x) => x._id !== addressToDelete?._id);
      const updateData: Customer = {
        addresses,
      };
      try {
        const response = await api.customer.updateCustomer(updateData, props.customerDetails?._id);
        setAddressToDelete(undefined);
        props.updateUser(response);
      } catch (error) {
        if (error?.response?.data?.data?.message) {
          toastr.error("Error", error?.response?.data?.data?.message.join());
        } else {
          toastr.error("Error", error?.response?.data?.message);
        }
      }
    }
  };

  const linkedin = props.customerDetails?.socialMediaIds?.find(
    (x) => x.name?.toLowerCase() === "linkedin"
  );

  const twitter = props.customerDetails?.socialMediaIds?.find(
    (x) => x.name?.toLowerCase() === "twitter"
  );

  const instagram = props.customerDetails?.socialMediaIds?.find(
    (x) => x.name?.toLowerCase() === "instagram"
  );

  const facebook = props.customerDetails?.socialMediaIds?.find(
    (x) => x.name?.toLowerCase() === "facebook"
  );
  const loadInfluence = async () => {
    const response = await api.influencer.loadAllInfluencer();
    return response;
  };

  const loadDesignation = async () => {
    const response = await api.designation.loadAllDesignation();
    return response;
  };

  const onSetCloseDate = (data: { date: Date }) => {
    try {
      updateSetClosingDate(data.date, leadState?.leadDetails?._id, () => {
        setShowSetExpectedCloseDate(false);
        props.updateUser(leadState?.leadDetails?.customer!);
        toastr.success("Success", "Closing date updated successfully");
      });
    } catch (error) {
      toastr.error("Error", error?.response?.data?.message);
    }
  };

  const on360Click = () => {
    history.push(`${RouteKeys.Lead360View}/${props.customerDetails?._id}`);
  };
  const renderDelete = () => {
    return addressToDelete ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>Are you sure want to delete this address</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={onCloseDeleteConfirm}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={onRemoveAddress}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  const languagesSpeak = props.customerDetails?.languagesSpeak?.filter(
    (x) => x !== props.customerDetails?.preferredLanguage
  );

  return (
    <>
      <div className="d-flex flex-wrap p-4 border-bottom">
        <div className=" avatar position-relative mr-2">
          {/* <div className="avatar__count rounded-circle bg-primary text-white font-normal font-weight-bold border border-white border-width-2 d-inline-flex align-items-center justify-content-center position-absolute">
            90
          </div> */}
          <CustomerAvatar
            id={props.customerDetails?._id}
            className="img-cover img-fluid rounded-circle "
            alt=""
            title={props.customerDetails?.name}
            imageUrl={props.customerDetails?.photo?.location}
            image={props.customerDetails?.photo}
          ></CustomerAvatar>
        </div>
        <div className="pl-1 flex-fill position-relative">
          <div className="row no-gutters align-items-center">
            <h4 className="font-weight-semibold mb-1">
              {props.customerDetails?.prefix ? props.customerDetails?.prefix + "." : ""}{" "}
              {!props.customerDetails?.isCompanyCustomer ? (
                <>
                  {" "}
                  {props.customerDetails?.firstName} {props.customerDetails?.lastName}
                  {props.customerDetails?.shortName && (
                    <span className="font-weight-normal">({props.customerDetails?.shortName})</span>
                  )}
                </>
              ) : (
                <> {props.customerDetails?.firstName} </>
              )}
            </h4>
            <div className="ml-auto">
              {props.customerDetails?.tags?.includes("VIP") && (
                <i className="icon-gold-member font-xl gold-member"></i>
              )}
            </div>
          </div>

          <div className="row no-gutters align-items-end">
            <div>
              {props.customerDetails?.primaryEmail && (
                <div className="font-sm font-weight-semibold">
                  <span className="font-xxs font-weight-normal text-gray-500">Email: </span>
                  <EmailLink>{props.customerDetails?.primaryEmail}</EmailLink>
                </div>
              )}
            </div>
          </div>
          <div className="row no-gutters align-items-end">
            <div>
              {props.customerDetails?.primaryPhone && (
                <div className="font-sm font-weight-semibold">
                  <span className="font-xxs font-weight-normal text-gray-500">Phone: </span>
                  <PhoneNumberCopy>{props.customerDetails?.primaryPhone}</PhoneNumberCopy>
                </div>
              )}
            </div>
          </div>
          <div className="row no-gutters align-items-end">
            <div>
              {props.customerDetails?.languagesSpeak &&
                props.customerDetails?.languagesSpeak?.length > 0 && (
                  <div className="font-sm font-weight-semibold">
                    <span className="font-xxs font-weight-normal text-gray-500">Language: </span>
                    {props.customerDetails?.preferredLanguage}
                    {languagesSpeak && languagesSpeak?.length > 0 && <>,</>}
                    {languagesSpeak?.join()}
                  </div>
                )}
            </div>
            {props.customerDetails?.socialMediaIds &&
              props.customerDetails?.socialMediaIds?.length > 0 && (
                <div className="ml-auto font-base">
                  {linkedin && (
                    <a href={linkedin.socialId} target="_blank">
                      <i className="icon-linkedin mr-2"></i>
                    </a>
                  )}
                  {twitter && (
                    <a href={twitter.socialId} target="_blank">
                      <i className="icon-twitter mr-2"></i>
                    </a>
                  )}
                  {instagram && (
                    <a href={instagram.socialId} target="_blank">
                      <i className="icon-instagram mr-2"></i>
                    </a>
                  )}
                  {facebook && (
                    <a href={facebook.socialId} target="_blank">
                      <i className="icon-facebook"></i>
                    </a>
                  )}
                </div>
              )}
          </div>
          {leadState?.leadDetails?.quality && (
            <div className="pointed-tag bg-primary text-white font-xxs text-uppercase d-inline-block rounded px-2 font-weight-semibold position-relative zIndex-1">
              {convertPascalCaseToWords(leadState?.leadDetails?.quality)}
            </div>
          )}

          {leadState?.leadDetails?.tags && leadState?.leadDetails?.tags?.length > 0 && (
            <div className="d-flex align-items-center py-2 my-1">
              <i className="icon-tag text-gray-600 mr-1"></i>
              {leadState?.leadDetails?.tags?.map((tag) => {
                return (
                  <div className="border rounded font-xxs tag-small d-inline-flex align-items-center px-1 mr-1 mb-1">
                    {tag}
                    {/* <i className="icon-close cursor-pointer"></i> */}
                  </div>
                );
              })}
            </div>
          )}
          {leadState.leadDetails?.isDeal && (
            <div ref={wrapperRef}>
              {leadState.leadDetails?.expectedClosingDate ? (
                <div className="d-flex align-items-center font-xxs font-weight-semibold text-primary mt-3">
                  <span className="font-xxs font-weight-normal text-gray-500">
                    Expected Closing Date :
                  </span>
                  {"  "}
                  {format(new Date(leadState.leadDetails?.expectedClosingDate), "dd/MM/yyyy")}
                  {canSetLeadClosingDate &&
                    (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                      <i
                        onClick={() => setShowSetExpectedCloseDate(true)}
                        className="cursor-pointer icon-edit ml-2"
                      ></i>
                    )}
                </div>
              ) : (
                <>
                  {canSetLeadClosingDate && (
                    <div
                      onClick={() => setShowSetExpectedCloseDate(true)}
                      className="cursor-pointer d-flex align-items-center font-xxs font-weight-semibold text-primary mt-3"
                    >
                      <i className="icon-flag mr-1 text-gray-900"></i> Set expected close date
                    </div>
                  )}
                </>
              )}

              {isShowSetExpectedCloseDate && (
                <div className="dropdown-menu dropdown-menu-right dropdown-shadow sm rounded font-sm border-0 w-100 in">
                  <div className="py-3 px-4">
                    <h6 className="font-weight-semibold mb-2 font-xs">
                      Select Expected Close Date<span className="text-danger">*</span>
                    </h6>
                    <form onSubmit={handleSubmit(onSetCloseDate)}>
                      <div className="row gutter-5">
                        <div className="col-8">
                          <Controller
                            control={control}
                            rules={{ required: true }}
                            name="date"
                            defaultValue={leadState?.leadDetails?.expectedClosingDate}
                            render={({ onChange, value, name }) => (
                              <DateInput
                                default={value}
                                placeholder={"DD/MM/YYYY"}
                                onChange={onChange}
                                minDate={new Date()}
                              />
                            )}
                          />
                          {errors.date && <ErrorMessage>Select Date</ErrorMessage>}
                        </div>

                        <div className="col-4">
                          <button className="btn btn-primary btn-block font-normal font-weight-semibold px-4">
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {props.show360Link && (
        <div
          className="d-flex border-bottom align-items-center py-2 px-4 cursor-pointer"
          onClick={on360Click}
        >
          <h6 className="mb-0">Customer 360 View</h6>
          <i className="icon-chevron-right icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto"></i>
        </div>
      )}
      <div className="d-flex border-bottom align-items-center py-2 px-4">
        <h6 className="mb-0">
          {!props.customerDetails?.isCompanyCustomer ? "Contact Details" : "Company Details"}{" "}
        </h6>
        <i className="icon-chevron-down icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto"></i>
      </div>
      {!editModal.isEditName ? (
        <div className="mt-2 d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Title</div>
          <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
            <div className="font-sm font-weight-semibold">{props.customerDetails?.prefix}</div>
            {canUpdateCustomerContacts &&
              (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                <i
                  onClick={() => setEditModal({ isEditName: true })}
                  className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                ></i>
              )}
          </div>
          <div className="w-100"></div>
          {!props.customerDetails?.isCompanyCustomer ? (
            <>
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">First Name</div>
              <div className="col pl-2 text-right-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">
                  {props.customerDetails?.firstName}
                </div>
              </div>
              <div className="w-100 mb-2"></div>
              {/* <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Middle Name</div> */}
              {/* <div className="col pl text-right-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">
                  {props.customerDetails?.middleName}{" "}
                </div>
              </div> */}
              <div className="w-100 mb-2"></div>
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Last Name</div>
              <div className="col pl-2 text-right-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">
                  {props.customerDetails?.lastName}{" "}
                </div>
              </div>{" "}
            </>
          ) : (
            <>
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Company Name</div>
              <div className="col pl-2 text-right-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">
                  {props.customerDetails?.firstName}
                </div>
              </div>
              <div className="w-100 mb-2"></div>
            </>
          )}
          <div className="w-100 mb-2"></div>
        </div>
      ) : (
        <EditName
          onClose={() => setEditModal({})}
          updateUser={(details: Customer) => props.updateUser(details)}
          customerDetails={props.customerDetails}
        ></EditName>
      )}
      {props.customerDetails?.parentCompanyCustomer && (
        <>
          {!editModal.isEditInfluencer ? (
            <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Influencer</div>
              <div className="col pl-2 text-right pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">
                  {props.customerDetails?.influencer?.name}
                </div>
                <i
                  onClick={() => setEditModal({ isEditInfluencer: true })}
                  className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                ></i>
              </div>
            </div>
          ) : (
            <EditSelectField
              onClose={() => setEditModal({})}
              updateUser={(details: Customer) => props.updateUser(details)}
              customerDetails={props.customerDetails}
              property={"influencerId"}
              value={props.customerDetails?.influencer?._id}
              title={"Influencer"}
              loadData={loadInfluence}
            ></EditSelectField>
          )}
        </>
      )}

      {!editModal.isEditPhone ? (
        <>
          <div className="d-flex flex-wrap px-4 py-1 contact-form-row flex-wrap">
            <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right pt-2">Phone</div>
            <div className="col pl-2 text-right-2 pr-0 contact-content d-flex align-items-center flex-wrap">
              {props.customerDetails?.phones?.length === 0 &&
                canUpdateCustomerContacts &&
                (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                  <i
                    onClick={() => setEditModal({ isEditPhone: true })}
                    className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                  ></i>
                )}

              {props.customerDetails?.phones?.map((item, index) => {
                return (
                  <>
                    {/* {item.isPrimary ? (
                      <i className="icon-tick font-xxxs text-shamrock mr-1"></i>
                    ) : (
                      <i className="icon-tick font-xxxs text-shamrock mr-1 hide-visibility"></i>
                    )} */}

                    <div className="font-sm font-weight-semibold">
                      +{item.phone}{" "}
                      {item.phoneType && <span className="text-gray-500">({item.phoneType})</span>}
                    </div>
                    {item.isPrimary && <i className="icon-primary-contact font-xs ml-1"></i>}
                    {index === 0 &&
                      canUpdateCustomerContacts &&
                      (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                        <i
                          onClick={() => setEditModal({ isEditPhone: true })}
                          className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                        ></i>
                      )}

                    <div className="w-100"></div>
                  </>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <EditPhone
          onClose={() => setEditModal({})}
          updateUser={(details: Customer) => props.updateUser(details)}
          customerDetails={props.customerDetails}
        ></EditPhone>
      )}

      {!editModal.isEditEmail ? (
        <>
          <div className="d-flex flex-wrap px-4 py-1 contact-form-row flex-wrap">
            <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right pt-2">E-mail</div>
            <div className="col pl-2 pr-0 contact-content d-flex align-items-center flex-wrap">
              {props.customerDetails?.emails?.length === 0 &&
                canUpdateCustomerContacts &&
                (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                  <i
                    onClick={() => setEditModal({ isEditEmail: true })}
                    className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                  ></i>
                )}

              {props.customerDetails?.emails?.map((item, index) => {
                return (
                  <>
                    {/* {item.isVerified === false ? ( */}
                    {item.isPrimary === false ? (
                      <i
                        className="font-weight-bold font-xxxs icon-close mr-1 text-red"
                        title="not verified"
                      ></i>
                    ) : (
                      <i className="icon-tick font-xxxs text-shamrock mr-1" title="verified"></i>
                    )}
                    <div className="font-sm font-weight-semibold">
                      {item.email}{" "}
                      {item.emailType && <span className="text-gray-500">({item.emailType})</span>}
                    </div>
                    {item.isPrimary && <i className="icon-primary-contact font-xs ml-1"></i>}
                    {index === 0 &&
                      canUpdateCustomerContacts &&
                      (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                        <i
                          onClick={() => setEditModal({ isEditEmail: true })}
                          className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                        ></i>
                      )}
                    <div className="w-100"></div>
                  </>
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <EditEmail
          onClose={() => setEditModal({})}
          updateUser={(details: Customer) => props.updateUser(details)}
          customerDetails={props.customerDetails}
        ></EditEmail>
      )}

      {/* {!editModal.isEditAgeLimit ? (
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Age Limit</div>
          <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
            <div className="font-sm font-weight-semibold">{props.customerDetails?.ageRange}</div>
            <i
              onClick={() => setEditModal({ isEditAgeLimit: true })}
              className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
            ></i>
          </div>
        </div>
      ) : (
        <EditSelectField
          onClose={() => setEditModal({})}
          updateUser={(details: Customer) => props.updateUser(details)}
          customerDetails={props.customerDetails}
          property={"ageRange"}
          value={props.customerDetails?.ageRange}
          title={"Age Limit"}
          options={AgeLimit.map((age) => ({ name: age.name, _id: age.name }))}
        ></EditSelectField>
      )} */}
      {!props.customerDetails?.isCompanyCustomer && (
        <>
          {/* {!editModal.isEditDob ? (
            <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right ">DOB</div>
              <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">
                  {props.customerDetails?.dob && (
                    <>
                      {format(new Date(props.customerDetails?.dob), "dd/MM/yyyy")}
                      <span className="text-gray-500">
                        ({differenceInYears(new Date(), new Date(props.customerDetails?.dob))} years
                        old)
                      </span>
                    </>
                  )}
                </div>
                {canUpdateCustomerContacts &&
                  (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                    <i
                      onClick={() => setEditModal({ isEditDob: true })}
                      className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                    ></i>
                  )}
              </div>
            </div>
          ) : (
            <EditDOB
              onClose={() => setEditModal({})}
              updateUser={(details: Customer) => props.updateUser(details)}
              customerDetails={props.customerDetails}
            ></EditDOB>
          )} */}

          {props.customerDetails?.gender && (
            <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">Gender</div>
              <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">{props.customerDetails?.gender}</div>
              </div>
            </div>
          )}
        </>
      )}

      {!isShowMore ? (
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap bg-white">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500"></div>
          <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
            <button
              onClick={() => setShowMore(true)}
              className="btn btn-link font-xs p-0 font-weight-semibold"
            >
              Show more
            </button>
          </div>
        </div>
      ) : (
        <>
          {/* <NonCompanyCustomerFields
            editModal={editModal}
            customerDetails={props?.customerDetails}
            setEditModal={setEditModal}
            updateUser={(details: Customer) => props.updateUser?.(details)}
          /> */}
          {/* {!editModal.isRemarks ? (
            <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 text-right">Remarks</div>
              <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                <div className="font-sm font-weight-semibold">{props.customerDetails?.remarks}</div>
                <i
                  onClick={() => setEditModal({ isRemarks: true })}
                  className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                ></i>
              </div>
            </div>
          ) : (
            <EditFiled
              onClose={() => setEditModal({})}
              updateUser={(details: Customer) => props.updateUser(details)}
              customerDetails={props.customerDetails}
              property={"remarks"}
              value={props.customerDetails?.remarks}
              title={"Remarks"}
              textArea
            ></EditFiled>
          )} */}

            {!editModal.isEditDesignation ? (
              <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap">
                <div className="col pl-0 pr-2 contact-label text-right font-xs text-gray-500 text-right ">
                  Designation
                </div>
                <div className="col pl-2 pr-0 contact-content d-flex align-items-center">
                  <div className="font-sm font-weight-semibold">
                    {props?.customerDetails?.designation?.name}
                  </div>
                  <i
                    onClick={() => setEditModal({ isEditDesignation: true })}
                    className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-auto contact-edit bg-white"
                  ></i>
                </div>
              </div>
            ) : (
              <EditSelectField
                onClose={() => setEditModal({})}
                updateUser={(details: Customer) => props.updateUser?.(details)}
                customerDetails={props?.customerDetails}
                property={"designationId"}
                searchable
                value={props?.customerDetails?.designation?.name}
                title={"Designation"}
                loadData={loadDesignation}
              ></EditSelectField>
            )}

          <div className="contact-label font-sm font-weight-semibold px-4 mt-1 ">Address</div>
          {canViewCustomerAddress && (
            <div className="d-flex flex-column py-1 ">
              {props.customerDetails?.addresses?.map((item) => {
                return (
                  <div className="contact-form-row ">
                    <div className="contact-content d-flex flex-column ">
                      <div className="d-flex mb-2 flex-column">
                        <div className="d-flex justify-content-end align-items-center ">
                          {item.isPrimary ? (
                            <i className="icon-tick font-xxxs text-shamrock mr-1 pt-1"></i>
                          ) : (
                            <i className="icon-tick font-xxxs text-shamrock mr-1 pt-1 hide-visibility"></i>
                          )}
                          {canUpdateCustomerContacts &&
                            (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                              <>
                                <i
                                  onClick={() => setAddressToDelete(item)}
                                  className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"
                                ></i>
                                <i
                                  onClick={() => selectAddress(item)}
                                  className="icon-edit icon-box cursor-pointer d-flex align-items-center justify-content-center border ml-3 contact-edit bg-white"
                                ></i>
                              </>
                            )}
                        </div>
                        <AddressDetalsView addressDetails={item} />
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="w-100 mb-3"></div>
              <div className="col pl-0 pr-2 contact-label font-xs text-gray-500"></div>
              {!editModal.isShowAddressForm &&
                canUpdateCustomerContacts &&
                (!leadState?.leadDetails || leadState?.leadDetails?.isEditable) && (
                  <button
                    onClick={() => selectAddress()}
                    className="btn btn-link font-sm p-0 font-weight-semibold"
                  >
                    + add{" "}
                    {props.customerDetails &&
                    props.customerDetails.addresses &&
                    props.customerDetails.addresses.length > 0
                      ? "one more"
                      : " address"}{" "}
                  </button>
                )}
            </div>
          )}

          {editModal.isShowAddressForm && (
            <AddAddress
              onClose={() => setEditModal({})}
              updateUser={(details: Customer) => props.updateUser(details)}
              selectedAddress={selectedAddress}
              customerDetails={props.customerDetails}
            ></AddAddress>
          )}
          <div className="d-flex flex-wrap px-4 py-1 contact-form-row align-items-center flex-wrap bg-white">
            <div className="col px-2 contact-label font-xs text-gray-500"></div>
            <div className="col px-2 contact-content d-flex align-items-center">
              <button
                onClick={() => setShowMore(false)}
                className="btn btn-link font-xs p-0 font-weight-semibold"
              >
                Show less
              </button>
            </div>
          </div>
        </>
      )}

      {renderDelete()}
    </>
  );
};

export default SearchCustomer;
